export default {
  findPaymentByIdInDb: function (state, idInDb) {
    return state.assetComponents
      .flatMap(assetComponent => assetComponent.lessorComponentShares)
      .flatMap(lessorComponentShare => lessorComponentShare.paymentsParameters)
      .find(payment => payment.idInDB === idInDb)
  }
}
